import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} ColorDeclarations
 */

const URL = 'color-declarations/';

const fetchColorDeclarations = async () => {
  return client.get(URL);
};

const fetchSingleColorDeclaration = async (id: number) => {
  return client.get(URL + id + '/');
};

const updateSingleColorDeclaration = async (id: number, data: any) => {
  return client.put(URL + id + '/', data);
};

const addColorDeclaration = async (data: any) => {
  const res = await client.post(URL, data);
  return res.data;
};

const actions = {
  fetchColorDeclarations,
  addColorDeclaration,
  fetchSingleColorDeclaration,
  updateSingleColorDeclaration,
};

export default actions;
